
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-internet)"}},[_c('path',{attrs:{"d":"M7.996.5A7.994 7.994 0 000 8.5c0 4.42 3.576 8 7.996 8a8.001 8.001 0 100-16zM8 2.128c.668.96 1.188 2.028 1.528 3.172H6.472c.34-1.144.86-2.212 1.528-3.172zM1.808 10.1A6.403 6.403 0 011.6 8.5c0-.552.076-1.088.208-1.6h2.7A13.157 13.157 0 004.4 8.5c0 .544.044 1.076.112 1.6H1.808zm.652 1.6h2.36c.26 1 .624 1.96 1.104 2.852A6.414 6.414 0 012.46 11.7zm2.36-6.4H2.46a6.413 6.413 0 013.464-2.852C5.444 3.34 5.08 4.3 4.82 5.3zM8 14.872A11.293 11.293 0 016.472 11.7h3.056A11.291 11.291 0 018 14.872zM9.872 10.1H6.128A11.115 11.115 0 016 8.5c0-.544.052-1.076.128-1.6h3.744c.076.524.128 1.056.128 1.6s-.052 1.076-.128 1.6zm3.664-4.8h-2.36c-.26-1-.624-1.96-1.104-2.848A6.406 6.406 0 0113.536 5.3zm-3.46 9.248c.48-.892.844-1.848 1.104-2.848h2.36a6.435 6.435 0 01-3.464 2.848zm1.412-4.448c.064-.524.112-1.056.112-1.6a12.4 12.4 0 00-.112-1.6h2.7c.132.512.212 1.048.212 1.6s-.076 1.088-.212 1.6h-2.7z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-internet"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    